import React, { useEffect, useState } from "react";
import useResponsiveScreen from "../../../hooks/useResponsiveScreen";
import CustomModal from "../../common/general/CustomModal/CustomModal";
import EditModule from "../EditModule/EditModule";

const EditModuleNameModalContainer = ({ visible, onClose, moduleName, onUpdateModuleName, moduleId }) => {
  const { isMedium } = useResponsiveScreen();
  const [newModuleName, setNewModuleName] = useState(moduleName);

  useEffect(() => {
    if (moduleName) {
      setNewModuleName(moduleName);
    } else {
      setNewModuleName("");
    }

    return () => {
      setNewModuleName("");
    };
  }, [visible, moduleName]);

  return (
    <CustomModal
      visible={visible}
      onRequestClose={onClose}
      style={{ width: isMedium ? "50%" : "90%", padding: 0, maxWidth: 500 }}>
      <EditModule
        onChangeName={setNewModuleName}
        moduleName={newModuleName ?? moduleName}
        saveButtonClick={() => onUpdateModuleName(moduleName, newModuleName, moduleId)}
        cancelButtonClick={onClose}
      />
    </CustomModal>
  );
};

export default EditModuleNameModalContainer;
